import React from 'react';
import { FaCalendarAlt } from 'react-icons/fa';

/**
 * Renders the input trigger element displaying the current date range.
 */
const DateRangeTrigger = ({ displayLabel, isOpen, onToggle }) => (
  <div
    className="form-control d-flex align-items-center justify-content-between"
    style={{ cursor: 'pointer', backgroundColor: '#fff', borderRadius: '6px', minWidth: '250px' }}
    onClick={onToggle}
    role="button"
    tabIndex={0}
  >
    <span style={{ fontSize: '14px', fontWeight: '500', color: '#333' }}>
      <FaCalendarAlt style={{ marginRight: '8px', color: '#555' }} />
      {displayLabel}
    </span>
    <span style={{ fontSize: '12px', color: '#888', marginLeft: '8px' }}>
      {isOpen ? '▲' : '▼'}
    </span>
  </div>
);

export default DateRangeTrigger;
